import React from "react";
import InfoGridList from "./infoGridList";
import { useCellRender } from "../hooks/useCellRender";
import {
  DATA_ORDER_APPLICATION_METHOD,
  DATA_ORDER_POLICY_DOCUMENT_TYPE,
} from "../data/options";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { getOrderPolicyNumberLabel } from "../helpers/orderProductUtils";
import { usePromotionModuleEnabled } from "../helpers/appFeatures";

const resolveOptionLabel = (options, value, t) => {
  if (!value) return "-";
  const option = options.find((o) => o.value === value);
  return option ? t(option.label) : value;
};

export default function OrderPolicy({ form, name }) {
  const [cellRender] = useCellRender();
  const { t } = useTranslation();
  const promotionModuleEnabled = usePromotionModuleEnabled();
  const order = name ? _.get(form.values, name) : form.values;
  const dataFontWeight = 600;

  const fields = [
    {
      title: t(getOrderPolicyNumberLabel(order)),
      value: order?.policyNumber,
    },
    {
      title: t("Application"),
      value: resolveOptionLabel(
        DATA_ORDER_APPLICATION_METHOD,
        order?.applicationMethod,
        t
      ),
    },
    {
      title: t("Policy"),
      value: resolveOptionLabel(
        DATA_ORDER_POLICY_DOCUMENT_TYPE,
        order?.policyDocumentType,
        t
      ),
    },
    {
      title: "Policy Commence Date",
      value: cellRender.Date(
        order?.policyCommenceDate,
        "YYYY-MM-DD",
        dataFontWeight
      ),
    },
    {
      title: "Policy Issue Date",
      value: cellRender.Date(
        order?.policyIssueDate,
        "YYYY-MM-DD",
        dataFontWeight
      ),
    },
    {
      title: "Policy Acknowledge Date",
      value: cellRender.Date(
        order?.policyAckSignDate,
        "YYYY-MM-DD",
        dataFontWeight
      ),
    },
    {
      title: "Policy Cool Off Expire",
      value: cellRender.Date(
        order?.policyCoolingOffDate,
        "YYYY-MM-DD",
        dataFontWeight
      ),
    },
    ...(promotionModuleEnabled
      ? [
          {
            title: "Promotion Points",
            value: (order?.pointBalances || []).length
              ? order.pointBalances
                  .map((row) => {
                    const name =
                      row.pointType?.name || row.pointType?.code || "Points";
                    const amount = Number(row.amount || 0).toLocaleString(
                      "en-US",
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    );
                    return `${name}: ${amount}`;
                  })
                  .join(" / ")
              : "-",
          },
        ]
      : []),
    {
      title: "Policy Delivery Method",
      value: order?.policyDeliverMethod ?? "-",
    },
    {
      title: "Delivery Date",
      value: cellRender.Date(
        order?.policyDeliverDate,
        "YYYY-MM-DD",
        dataFontWeight
      ),
    },

    {
      title: "Remark",
      value: order?.policyRemark ?? "-",
    },
    {
      title: "Delivery Remark",
      value: order?.policyDeliverRemark ?? "-",
    },
    {
      title: "Professional Investor",
      value: order?.professionalInvestor ? "Yes" : "No",
    },
    {
      title: "Mainland Chinese Visitor",
      value: order?.mainlandChineseVisitor ? "Yes" : "No",
    },
    {
      title: "Date Back Option",
      value: order?.dateBackOption ? "Yes" : "No",
    },
    {
      title: "Premium Financing",
      value: order?.premiumFinancing ? "Yes" : "No",
    },
    {
      title: "Policy Replacement",
      value: order?.policyReplacement ? "Yes" : "No",
    },
  ];
  return <InfoGridList fields={fields} values={order} />;
}
